import React from 'react';
import Logs from 'components/Logs';

const VehicleTypeLogs = ({ id }) => {
  return <Logs targetId={parseInt(id)} targetType="VehicleType" title="Vehicle type logs" />;
};

export default VehicleTypeLogs;
